/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Note_LabelInputs */

const en_admin_invite_codes_note_label = /** @type {(inputs: Admin_Invite_Codes_Note_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const zh_admin_invite_codes_note_label = /** @type {(inputs: Admin_Invite_Codes_Note_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备注`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Admin_Invite_Codes_Note_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_note_label = /** @type {((inputs?: Admin_Invite_Codes_Note_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Note_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_note_label(inputs)
	return zh_admin_invite_codes_note_label(inputs)
});
export { admin_invite_codes_note_label as "admin.invite_codes.note_label" }